import { render, staticRenderFns } from "./div-padding.vue?vue&type=template&id=10898d31&scoped=true"
import script from "./div-padding.vue?vue&type=script&lang=js"
export * from "./div-padding.vue?vue&type=script&lang=js"
import style0 from "./div-padding.vue?vue&type=style&index=0&id=10898d31&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10898d31",
  null
  
)

export default component.exports